var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');
var responsiveToolkit = require('src/interlock/no-ui/utils/responsive-bootstrap-toolkit/responsive-bootstrap-toolkit');
var debounce = require('throttle-debounce/debounce');

var pageValues = window.EDM.PageValues = window.EDM.PageValues || {};

var debouncedHandler = debounce(100, function () {
    responsiveToolkit.changed(function() {
        pageValues.breakpoint = responsiveToolkit.current();
        eventToolbox.fireAction({
            'ads': {
                'enable_retarget': true,
                'retarget_exclude_special_case': true
            }
        });
    });
    eventToolbox.fireAction({
        'browser_width': window.innerWidth,
        'ads': {
            'disable_refresh': true
        }
    });
});

/**
 * Breakpoint detection
 */
$(document).ready(function() {
    $(window).resize(debouncedHandler);
});



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/engagement-handler/breakpoint-engagement-handler/breakpoint-engagement-handler.js
// module id = 430
// module chunks = 36